import {Component, Input} from '@angular/core';
import {LineChartData} from "../../../interfaces/line-chart-data";

@Component({
  selector: 'brt-school-class-compare-block-chart',
  templateUrl: './school-class-compare-block-chart.component.html',
  styleUrls: ['./school-class-compare-block-chart.component.scss']
})
export class SchoolClassCompareBlockChartComponent {

  @Input('lineChartData') set setData(val: LineChartData) {
    let totalItems = 0;

    val.datasets.forEach(dataset => {
      totalItems += dataset.items.length;
    });

    this.hasAnyData = totalItems > 0;
    this.lineChartData = val;
  }

  @Input("chartTarget") chartTarget: "points" | "playTime" = "points"

  hasAnyData = false;
  lineChartData!: LineChartData;

}
